import { UserCheck, ShieldCheck, Scale, HeartHandshake } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const values = [
  { icon: UserCheck, title: 'Clinical Sovereignty', body: 'We believe the surgeon is the only source of truth. Our system protects that truth.' },
  { icon: ShieldCheck, title: 'Zero-Guess Policy', body: "We never use 'probability' to suggest codes. We only use evidence to prove them." },
  { icon: Scale, title: 'Defensibility', body: "We don't just help you get paid; we ensure you keep the money during an audit." },
  { icon: HeartHandshake, title: 'Administrative Relief', body: "We remove the 'shadow-work' from the surgical team so they can focus on outcomes." },
];

export function IntegrityValues() {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs font-semibold tracking-widest uppercase text-muted-foreground mb-4">
              Our Principles
            </p>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
              The "Integrity First" Values.
            </h2>
            <p className="text-muted-foreground text-lg max-w-xl mx-auto">
              Every design decision, every line of logic — anchored to these
              non-negotiable principles.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {values.map((v) => (
              <Card key={v.title} className="bg-card border border-border rounded-xl transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 mb-5">
                    <v.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-3">{v.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{v.body}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
